(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('groupe-planning', {
                url: '/groupe-planning?page&sort',
                parent: 'gestion',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'tmgApp.groupe-planning.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/groupe-planning/groupe-planning.html',
                        controller: 'GroupePlanningController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('groupePlanning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('groupe-planning.new', {
                parent: 'groupe-planning',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-dialog.html',
                        controller: 'GroupePlanningDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    name: null,
                                    enabled: false,
                                    color: null,
                                    order: null,
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('groupe-planning', null, { reload: 'groupe-planning' });
                    }, function() {
                        $state.go('groupe-planning');
                    });
                }]
            })
            .state('groupe-planning.edit', {
                parent: 'groupe-planning',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-dialog.html',
                        controller: 'GroupePlanningDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['GroupePlanning', function(GroupePlanning) {
                                return GroupePlanning.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('groupe-planning', null, { reload: 'groupe-planning' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('groupe-planning-detail', {
                parent: 'groupe-planning',
                url: '/groupe-planning/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'tmgApp.groupePlanning.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-detail.html',
                        controller: 'GroupePlanningDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('groupePlanning');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'GroupePlanning', function($stateParams, GroupePlanning) {
                        return GroupePlanning.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'groupe-planning',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('groupe-planning.delete', {
                parent: 'groupe-planning',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-delete-dialog.html',
                        controller: 'GroupePlanningDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['GroupePlanning', function(GroupePlanning) {
                                return GroupePlanning.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('groupe-planning', null, { reload: 'groupe-planning' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
